import React from "react";
import { useQuery, gql } from "@apollo/client";
import { Row, Col } from "reactstrap";
import DatetimeRenderer from "../../Material/DatetimeRenderer";
import Skeleton from "react-loading-skeleton";
import "./HistoryTab.css";

const INCIDENT_HISTORY_QUERY = gql`
  query IncidentHistory($incidentId: ID!) {
    incident(incidentId: $incidentId) {
        id
        history { 
            date 
            user 
            comment 
        }  
    }
}`;

const parseHistoryComment = (comment = "") => {
    const firstColon = comment.indexOf(":");
    const title = firstColon !== -1 ? comment.slice(0, firstColon).trim() : "";
    const detail = firstColon !== -1 ? comment.slice(firstColon + 1).trim() : comment.trim();

    const detailColon = detail.indexOf(":");
    const fieldLabel = detailColon !== -1 ? detail.slice(0, detailColon).trim() : "";
    const valuePart = detailColon !== -1 ? detail.slice(detailColon + 1).trim() : detail;

    const arrowIndex = valuePart.indexOf("->");
    const oldValue = arrowIndex !== -1 ? valuePart.slice(0, arrowIndex).trim() : "";
    const newValue = arrowIndex !== -1 ? valuePart.slice(arrowIndex + 2).trim() : "";

    return { title, fieldLabel, valuePart, oldValue, newValue };
};

const HistoryTab = ({ incidentId, history }) => {
    const { data, loading } = useQuery(INCIDENT_HISTORY_QUERY, {
        variables: { incidentId },
        skip: !incidentId || !!history,
    });

    let incidentHistory = history;
    if (!history && incidentId) {
        if (loading) return [...Array(5)].map((_, ridx) => (
            <Row key={ridx}>{[...Array(4)].map((_, cidx) => (<Col key={cidx}><Skeleton height={20} /></Col>))}</Row>
        ))
        const incident = data?.incident;
        if (!incident) return null;
        incidentHistory = incident.history;
    }


    return (
        <div className="history-list">
            {Array.isArray(incidentHistory) && incidentHistory.length > 0 ? (
                incidentHistory.map((h, idx) => {
                    const { title, fieldLabel, valuePart, oldValue, newValue } = parseHistoryComment(h.comment || "");
                    return (
                        <div key={idx} className="history-item">
                            <div className="history-item__title">{title || "History Update"}</div>
                            <div className="history-item__detail">
                                {fieldLabel && <span className="history-item__label">{fieldLabel}:</span>}
                                {oldValue || newValue ? (
                                    <span className="history-item__change">
                                        <span className="history-item__old">{oldValue || "--"}</span>
                                        <span className="history-item__arrow">→</span>
                                        <span className="history-item__new">{newValue || "--"}</span>
                                    </span>
                                ) : (
                                    <span className="history-item__value">{valuePart || "--"}</span>
                                )}
                            </div>
                            <div className="history-item__meta">
                                <DatetimeRenderer datetime={h.date} />
                                {h.user ? ` by ${h.user}` : ""}
                            </div>
                        </div>
                    );
                })
            ) : (
                <Row><Col>No history available</Col></Row>
            )}
        </div>
    );
};

export default HistoryTab;
